import { subDays, startOfDay, endOfDay, format } from 'date-fns';

export { subDays, startOfDay, endOfDay, format };

/**
 * Seconds to ISO8601 duration or date string
 */
export function secondsToISO8601(input: number, timeOnly = false): string {
  if (!input) {
    return '';
  }

  const date = new Date(input ? input * 1000 : 0);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  if (!timeOnly) {
    return date.toISOString();
  }

  let isoString = 'PT';
  if (hours > 0) { isoString += hours + 'H'; }
  if (minutes > 0) { isoString += minutes + 'M'; }
  if (seconds > 0) { isoString += seconds + 'S'; }

  return isoString;
}

export const is12HourClock = () => {
  const date = new Date(Date.UTC(2022, 6, 20, 18, 0, 0));
  return /am|pm/i.test(date.toLocaleTimeString());
};

export const formatDateDDMMYYYY = (dateStr?: string | null) => {
  if (!dateStr) { return '-'; }
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) { return '-'; }
  return format(date, 'dd/MM/yyyy');
};

export const formatToLocalDateTime = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  const timezoneOffsetMinutes = -date.getTimezoneOffset();
  const sign = timezoneOffsetMinutes >= 0 ? '+' : '-';
  const absoluteOffset = Math.abs(timezoneOffsetMinutes);
  const offsetHours = String(Math.floor(absoluteOffset / 60)).padStart(2, '0');
  const offsetMinutes = String(absoluteOffset % 60).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
};

export const formatDateMMMddYYYY = (dateStr?: string | null) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '-';

  return format(date, 'MMM dd, yyyy'); // Output: Feb 20, 2023
};